import { Injectable, Pipe, PipeTransform } from '@angular/core';
// import { AnyAction } from 'redux';
import * as moment from 'moment-timezone';
@Pipe({
  name: 'convertUtcToLocale'
})
@Injectable()
export class ConvertUtcToLocale implements PipeTransform {

  abbrs = {
    'Eastern Standard Time': '−05:00',
    'Eastern Daylight Time': '−04:00',
    'Central Standard Time': '-06:00',
    'Central Daylight Time': '-05:00',
    'Mountain Standard Time': '-07:00',
    'Mountain Daylight Time': '-06:00',
    'Pacific Standard Time': '-08:00',
    'Pacific Daylight Time': '-07:00',
};

  transform(Value: any, dateFormat: any, abbrs: any) {
    if (dateFormat) {
      return moment
        .utc(Value)
        .utcOffset(this.abbrs[abbrs])
        .format(dateFormat);
    } else {
      return moment.utc(Value).utcOffset(this.abbrs[abbrs]);
    }
  }
}
